'use client'

import styled from '@emotion/styled'

import theme from 'styles/theme'

export const ProductImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
  width: 100%;
  border: 1px solid ${theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.small')};
  margin-bottom: 24px;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    margin-bottom: 0px;
  }
`

export const StyledSlider = styled.div`
  overflow: hidden;
  position: relative;
  height: 95%;
  width: 95%;
`

export const Slide = styled.div<{
  isActive: boolean
  isPrevious: boolean
  isNext: boolean
}>`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: ${({ isNext, isPrevious }) =>
    isNext ? 'translateX(100%)' : isPrevious ? 'translateX(-100%)' : 'translate(0)'};
  z-index: ${({ isActive, isPrevious, isNext }) => (isActive ? 0 : isNext || isPrevious ? 800 : 100)};
  transition: transform 0.5s, opacity 0.5s, z-index 0.5s;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`

export const SliderBullet = styled.div<{ isActive: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: ${({ isActive }) =>
    isActive ? theme.token.var('colors.green.a200') : theme.token.var('colors.green.a100')};
  margin: 0 4px 0 4px;
  transition: background 0.3s ease;
  z-index: 99999;
`

export const SlidePreview = styled.button`
  border: 1px solid ${theme.token.var('colors.green.a50')};
  height: 70px;
  border-radius: ${theme.token.var('borderRadius.small')};
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 65%;
  }
`
